import { Controller } from '@hotwired/stimulus';

// Barre de navigation : panneau du menu sous 1280 px
// (bouton ☰, et « Plus » de la barre du bas de l'adhérent) et menus
// déroulants (<details>, un seul ouvert), refermés par Échap, par un clic
// hors de la barre et avant la mise en cache Turbo.
export default class extends Controller {
    static targets = ['panel', 'toggle', 'menu'];

    toggle() {
        if (this.panelTarget.hidden) {
            this.panelTarget.hidden = false;
            this.toggleTargets.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
        } else {
            this.close();
        }
    }

    close() {
        this.panelTarget.hidden = true;
        this.toggleTargets.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
        this.menuTargets.forEach((menu) => { menu.open = false; });
    }

    closeOutside(event) {
        if (!this.element.contains(event.target)) this.close();
    }

    exclusive(event) {
        if (!event.target.open) return;
        this.menuTargets.filter((menu) => menu !== event.target).forEach((menu) => { menu.open = false; });
    }
}
